<template>
<div>
  <h5 class="mb-4">정기위험성평가</h5>
  <search-nav size="mobile" align="justify-end" @handleSearch="handleSearch">
    <search-nav-item-date class="w-full" size="mobile" label="공사시간" v-model="nav.date" ></search-nav-item-date>
    <search-nav-item-keyword class="w-full" size="mobile" label="키워드" v-model="nav.keyword"></search-nav-item-keyword>
  </search-nav>
  <div class="flex mb-4" style="justify-content: flex-end;">
    <vs-button class="w-1/2 px-0 mr-2" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
    <vs-button class="w-1/2 px-0 " color="secondary" @click="handleClickRegister">신규작성</vs-button>
  </div>
  <div style="margin:0 -1.2rem;">
    <vs-table
              style="border:1px solid #cdcdcd; border-radius: 0;"
              stripe
              ref="table"
              :sst="true"
              :max-items="table.perPage"
              :data="table.list"
              noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
              @sort="handleSort"
              @selected="handleItemClickDetail">

      <template slot="thead">

        <vs-th sort-key="id" style="min-width:60px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.No')}}</vs-col></vs-th>
        <vs-th sort-key="content$preview.title" style="min-width:150px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.사무소명')}}</vs-col></vs-th>
        <vs-th sort-key="content$preview.company" style="min-width:150px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.파트너사')}}</vs-col></vs-th>
        <vs-th sort-key="content$preview.processType" style="min-width:150px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.대상공종')}}</vs-col></vs-th>
        <vs-th sort-key="contentd$preview.orderNumber" style="min-width:60px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.차수')}}</vs-col></vs-th>
        <vs-th sort-key="created_at" style="min-width:120px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.대상기간')}}</vs-col></vs-th>
        <vs-th sort-key="created_at" style="min-width:150px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.작성일')}}</vs-col></vs-th>
        <vs-th sort-key="content$preview.writer" style="min-width:100px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.작성자')}}</vs-col></vs-th>
        <vs-th sort-key="status" style="min-width:100px;"><vs-col vs-type="flex" vs-justify="center">{{$t('project.risk.assessment.regular.column.결재상태')}}</vs-col></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="text-center">{{ getContent(tr).id }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).title }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).company }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).processType }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).orderNumber }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).begin_ymd }} ~ {{ getPreview(tr).end_ymd }}</vs-td>
          <vs-td class="text-center">{{ getContent(tr).created_at.substr(0,10) }}</vs-td>
          <vs-td class="text-center">{{ getPreview(tr).writer }}</vs-td>
          <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination
          :total="(lastPage) ? lastPage : 1"
          v-model="currentPage" @change="handleChangePage"></k-pagination>
      </div>
    </div>
  </div>

  <popup-approval-process
    :show-popup="showApprovalLinePopup"
    @closePopup="handleCloseApprovalPopup" />
</div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import KPagination from '@/views/components/kPagination/kPagination'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
export default {
  name: 'MobileSafetyRegularAssessment',
  components: {
    PopupApprovalProcess,
    KPagination,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  computed: {
    rootPath () {
      const paths = this.$route.path.split('/')
      return `/${paths[1]}/${paths[2]}/${paths[3]}`
    }
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        keyword: '',
        orderTarget:'created_at',
        orderDirection:'desc'
      },

      currentPage: 1,
      lastPage: 1,
      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },
      showApprovalLinePopup: false,
    }
  },
  created () {
    this.loadPostList()
  },

  methods: {
    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardSlug = 'periodical_risk' // first_risk(id:6)
      const page = this.currentPage
      const perPage = this.table.perPage
      const keyword = []
      const periodTargetBegin = 'preview.begin_ymd'
      const periodTargetEnd = 'preview.end_ymd'
      const periodDateBegin = this.nav.date[0]
      const periodDateEnd = this.nav.date[1]
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection

      if (this.nav.keyword) {
        keyword.push(this.nav.keyword)
      }

      await this.$store.dispatch('approval/LOAD_POST_ALL', {projectId, boardSlug, page, perPage, keyword,
        periodTargetBegin, periodTargetEnd, periodDateBegin, periodDateEnd, orderTarget, orderDirection})

      this.table.list = this.$store.state.approval.list
      const listInfo = this.$store.state.approval.postListInfo
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page

    },

    handleSearch () {
      this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getContent (data) {
      if (data.post) {
        const content = data.post
        return content
      }
    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type
        this.loadPostList()
      }

    },

    handleItemClickDetail (data) {
      this.$router.push(`${data.post_id}/regular-assessment-update`)
    },
    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    handleClickRegister () {
      this.$router.push('regular-assessment-create')
    }
  }
}
</script>

<style scoped>

</style>
